import { css } from "@emotion/css";
import React, { createRef, useLayoutEffect, useState } from "react";

import { useScrollContainerStyles } from "./styles";
import { ScrollContainerProps } from "./types";

export type { ScrollContainerProps };

export function ScrollContainer(props: ScrollContainerProps) {
  const { children } = props;
  const styles = useScrollContainerStyles(props);
  const ref = createRef<HTMLDivElement>();

  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(true);

  const refreshScrollPosition = () => {
    if (ref.current) {
      const { scrollTop, clientHeight, scrollHeight } = ref.current;

      setAtTop(scrollTop === 0);
      setAtBottom(scrollHeight <= clientHeight + scrollTop);
    }
  };

  useLayoutEffect(refreshScrollPosition);

  return (
    <div className={styles.container}>
      <section
        className={styles.contents}
        onScroll={refreshScrollPosition}
        ref={ref}
        tabIndex={atTop && atBottom ? undefined : 0}
      >
        {children}
      </section>
      <div className={css(styles.topGradient, !atTop && { opacity: 1 })} />
      <div
        className={css(styles.bottomGradient, !atBottom && { opacity: 1 })}
      />
    </div>
  );
}
